export default __webpack_public_path__ + "static/media/logo-whatsapp.4a5048df.svg";